module.exports = __webpack_public_path__ + "img/bands.992622e4.png";